module.exports = __webpack_public_path__ + "static/media/spin.71fa438e.svg";